export const loadSrcToImage = async (src: string, image: HTMLImageElement) => {
    return new Promise<void>((resolve, reject) => {
        image.src = src;
        image.onload = () => {
            resolve();
        };
        image.onerror = () => {
            reject();
        };
    });
};
